import Phaser from "phaser";

export class ScorePopup {
    static spawn(scene: Phaser.Scene, x: number, y: number, value: number): void {
        const safeValue = Number.isFinite(value) ? value : 0;
        const label = scene.add
            .text(x, y, `+${safeValue}`, {
                fontSize: "30px",
                color: safeValue >= 50 ? "#ffe08f" : "#d6f4ff",
                fontStyle: "bold",
            })
            .setOrigin(0.5)
            .setDepth(120);

        scene.tweens.add({
            targets: label,
            y: y - 50,
            alpha: 0,
            duration: 550,
            ease: "Sine.easeOut",
            onComplete: () => label.destroy(),
        });
    }
}
